import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListBlacklistSources from '../../components/blacklist-sources/list-blacklist-sources.component';

const BlacklistSources = () => {
  const pageTitle = 'Settings / Blacklist Sources';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListBlacklistSources />
    </AppLayout>
  );
};

export default BlacklistSources;
